import {getId, getType} from 'apis/model/base'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {OpeningCourses} from 'views/AppLocals/Course/components/OpeningCourses'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import OrganizationContainerContext from '../OrganizationContainerContext'
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {course_getCourses_Api} from "../../../../apis/course";
import {FiChevronsRight} from "react-icons/fi";
import {useHistory} from "../../../../modules/navigation/useRouter";
import {scrollToRow} from "../../Missal/functions/scrollToRow";
import {WrapperBlockSider} from "../components/WrapperBlockSider";
import {FaChalkboardTeacher} from "react-icons/fa";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";

const OrganizationOpeningCourses = () => {
    const t = useTranslate()
    const {isLg} = useContext(LayoutContext)
    const {organization: item} = useContext(OrganizationContainerContext)
    const owner_id = getId(item)
    const owner_type = getType(item)
    const history = useHistory()

    return (
        <OpeningCourses
            id={[course_getCourses_Api.path, owner_type, owner_id].join("/")}
            values={{status: 1, valid: 1}}
            query={bindQueryParams([{id: owner_id}, {type: owner_type}])}
            renderWrap={(children, __, count) => {
                return !!count && (
                    <WrapperBlockSider
                        title="courses" titleColor="text-green-700" expanded={!isLg}
                        borderLeft={isLg}
                        borderTop={!isLg}
                        icon={<FaChalkboardTeacher size={18} className="text-green-500"/>}>
                        <div className="flex flex-col gap-4">
                            {children}
                        </div>
                    </WrapperBlockSider>
                )
            }}
            renderLoadMore={() => (
                <span
                    className="flex items-center justify-end gap-1 text-color-400 hover:text-color-100 cursor-pointer"
                    onClick={() => {
                        scrollToRow('contentOrg');
                        history.push(getLinkToDetail(item) + '/courses')
                    }}>
                    <span className="text-xs italic">
                        {t('see more')}
                    </span>
                    <FiChevronsRight size={13} className="my-auto"/>
                </span>
            )}
        />
    )
}

export default OrganizationOpeningCourses
